import { useEffect, useRef } from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Showcase from "@/components/landing/Showcase";
import MediaGallery from "@/components/landing/MediaGallery";
import TrustBar from "@/components/landing/TrustBar";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import FloatingWhatsapp from "@/components/landing/FloatingWhatsapp";
import CookieBanner from "@/components/landing/CookieBanner";
import MaintenancePage from "@/pages/MaintenancePage";
import { useSettings } from "@/hooks/useSettings";
import { trackPageView } from "@/lib/tracking";

export default function LandingPage() {
  const { settings, loading } = useSettings();
  const contactRef = useRef(null);
  const cookieRef = useRef(null);

  useEffect(() => {
    trackPageView("/");
  }, []);

  if (loading || !settings) {
    return (
      <div
        className="min-h-screen flex items-center justify-center bg-mfp-bg text-mfp-muted text-sm uppercase tracking-widest"
        data-testid="landing-loading"
      >
        Laden …
      </div>
    );
  }

  // Maintenance mode: replace the entire public landing experience.
  // Admin routes (/admin/*) and legal routes (/impressum, /datenschutz) are not affected.
  if (settings.maintenance_mode) {
    return <MaintenancePage />;
  }

  const handleSelectPackage = (pkgId) => {
    contactRef.current?.setPackage(pkgId);
  };

  return (
    <div className="bg-mfp-bg text-mfp-champagne min-h-screen" data-testid="landing-page">
      <Header />
      <Hero settings={settings} />
      <TrustBar />
      <Showcase settings={settings} />
      <MediaGallery settings={settings} />
      <Pricing onSelectPackage={handleSelectPackage} />
      <FAQ />
      <Contact ref={contactRef} settings={settings} />
      <Footer onOpenCookieSettings={() => cookieRef.current?.openSettings()} />
      <FloatingWhatsapp number={settings.whatsapp_number} />
      <CookieBanner
        ref={cookieRef}
        gtmId={settings.gtm_id}
        metaPixelId={settings.meta_pixel_id}
      />
    </div>
  );
}
